
import { compact, notBlank } from '~/utils/helpers'


const PlpInit = () => {

  const fillCollection = (coll) => {

    coll.prods_pk = compact(coll?.prods_pk || [])
    coll.prods_pk.forEach(x => {
      x.pl_pima = 99998
      x.product_line = {pima_id: 99998}
    })
    coll.products = compact(coll.products)
    let allProducts = fillData(coll)

    let initProducts = []
    let initUngroups = []
    let allFilters = parseFilters(allProducts, coll.filter_order)
    const currGroup = coll.rules?.grp_default || false
    const is_all = coll.handle === 'all' || coll.handle.includes('-all')

    if (is_all) {
      coll.groups = catsGroups({coll, allProducts})
      coll.prods_grouped = catsProds(coll.groups)
    }

    let initTestProducts = null

    if (!currGroup) {
      initProducts = initProdsNoGroup({coll, allProducts})
      initTestProducts = initProdsNoGroup({coll, allProducts, test: true})
      if (!!initTestProducts) initTestProducts = [initTestProducts]
    } else {
      initProducts = initProdsGroup({coll, allProducts})
      initUngroups = checkUngroups({coll, allProducts})
    }

    let shw_singpl = coll?.rules?.shw_singpl || false
    if (shw_singpl) initProducts = checkSingle({initProducts, coll})
    
    coll.products = allProducts
    coll.allFilters = allFilters
    coll.initUngroups = initUngroups
    coll.initProducts = checkSplit(initProducts)
    coll.groups = compact(coll?.groups || [])
    coll.initGroupNav = checkGroupNav({coll})
    coll.product_lines = compact(coll?.product_lines || [])
    coll.initTestProducts = initTestProducts

    return coll
  }

  const fillData = (collection) => {
    if (!collection?.products) return []

    const tile_imgs = collection.tile_imgs || []

    return collection?.products.map(product => {
      if (product.is_vintage) return product
      const pl_id = product.product_line.mid
      if (product.product_line.pima_id === 99998) return product

      const { product_lines, callouts} = collection

      product.callouts = product.ncallouts.map(c_id => callouts.find(x => x?.mid === c_id))
      if (product.callouts.length) {
        product.callouts = compact(product.callouts).map(x => x.data)
      }

      const product_line = product_lines.find(x => x?.mid === pl_id)
      if (!product_line) return product

      let pl_filters = JSON.parse(JSON.stringify(product_line.filters || {}))
      Object.keys(product.filters).forEach(x => {
        if (pl_filters.hasOwnProperty(x)) {
          pl_filters[x] = [...new Set(pl_filters[x].concat(product.filters[x]))]
        } else {
          pl_filters[x] = product.filters[x]
        }
      })

      let color_type = product.handle.includes('venice-wash') ? 'venice_wash' : 'standard'
      let color_obj = {}
      if (product_line.handle !== "gift-card") {
        color_obj = product_line.colors[color_type].find(x => x.shop_id === product.shop_id) || color_obj
      }

      let media = product.media
      const tileimg = tile_imgs.find(x => x.id === product.mid)
      let adds = []
      if (tileimg) {
        if (!!tileimg.face_url || !!media[tileimg.face_ind]) {
          media.forEach(x => delete x.face)
        }
        if (!!tileimg.hover_url || !!media[tileimg.hover_ind]) {
          media.forEach(x => delete x.hover)
        }
        if (!!tileimg.face_url) {
          adds.push({src: tileimg.face_url, type: 'IMAGE', face: true})
        } else if (!!media[tileimg.face_ind]) {
          media[tileimg.face_ind].face = true
        }
        if (!!tileimg.hover_url) {
          adds.push({src: tileimg.hover_url, type: 'IMAGE', hover: true})
        } else if (!!media[tileimg.hover_ind]) {
          media[tileimg.hover_ind].hover = true
        }
      }
      media = adds.concat(media)

      product = {...product, 
        color: color_obj,
        filters: pl_filters,
        gender: product_line.gender,
        category: product_line.category,
        media: media,
        pl_colors: product_line.colors,
        pl_handle: product_line.handle,
        pl_name: product_line.name,
        short_description: product.short_description ? product.short_description : product_line.short_description
      }

      if (product.variants && product.variants.length > 0) {
        product.variants.forEach(x => x['sku'] = `${product.sku}${x.title}`)
      }

      return product
    })
  }

  const parseFilters = ( prods, filter_order=[] ) => {
    if ( !prods ) return false

    const filter_obj = {}

    let sizes = prods.map(x => x).filter(x => !!x && x.pl_pima !== 99998 && x.pl_pima !== 99999).map(x => x.filters)
    sizes = [...new Set( sizes.filter(x => !!x && x.hasOwnProperty('size')).map(x => x.size).flat() )]
    if (sizes.length > 0) filter_obj['size'] = sizes

    prods.filter(x => x !== null && x.pl_pima !== 99998).forEach( product => {
      if (product === null || !product.hasOwnProperty('filters')) return

      const keys = Object.keys(product.filters).filter( x => {
        const bads = ['groupfabric','groupmarketing','gift','inseam','size','locations']
        return x === 'gender' || (!bads.includes(x) && filter_order.includes(x))
      })

      keys.forEach( k => {
        const name = k === 'groupstyle' ? 'style' : k
        filter_obj[name] ||= [] 
        const vals = product.filters[k]
        const vals_arr = vals ? vals.map(x => x && x.toLowerCase()) : []
        filter_obj[name] = [...new Set( filter_obj[name].concat(vals_arr) )]
      })
    })

    return filter_obj
  }

  const initProdsNoGroup = ({coll, allProducts, test=false}) => {
    if (!allProducts) return []
    if (test && !coll.test_prods) return null

    let products = coll?.prods_coll || []
    if (test && !!coll.test_prods) products = coll.test_prods

    products = products.map(id => {
      let prod = allProducts.find(x => x?.mid === id)
      if (!prod) prod = coll.prods_pk.find(x => x?.mid === id)
      return prod
    })

    products = compact(products)

    return products
  }

  const initProdsGroup = ({coll, allProducts}) => {
    const handle = coll.handle
    const is_all = handle === 'all' || handle.includes('-all')

    const { groups, prods_grouped, prods_pk } = coll

    const currGroup = coll.rules?.grp_default || false
    const group_name = currGroup.includes('group') ? currGroup : `group${currGroup}`

    let group_arr = groups.filter(x => x?.type === group_name)
    
    for (const item of group_arr) {
      let grp_prods = prods_grouped.find(x => x?.mid === item.mid)
      if (!grp_prods || !grp_prods.hasOwnProperty('products')) continue
      grp_prods = grp_prods.products.map(prod_id => {
        const found_prod = allProducts.find(x => x?.mid === prod_id)
        const found_pk = prods_pk.find(x => x?.mid === prod_id)
        if (found_pk) found_pk['pl_pima'] = 99998
        return found_prod || found_pk
      })
      grp_prods = compact(grp_prods).filter(x => !x.is_alt_cut)
      item.products = grp_prods
    }

    group_arr = compact(group_arr).filter(x => x?.products?.length > 0)

    return group_arr
  }


  const checkUngroups = ({coll, allProducts}) => {
    const ungrouped = coll.ungrouped || {}
    const currGroup = coll.rules?.grp_default || null
    if (!ungrouped || !ungrouped[currGroup]) return []
    
    let new_ungrouped = ungrouped[currGroup].map(id => allProducts.find(x => x?.mid === id))

    return compact(new_ungrouped)
  }

  const checkSplit = (products) => {
    const is_block = (obj) => {
      return obj.hasOwnProperty('blocks') && obj.blocks && obj.blocks.length > 0
    }

    let checked_products = structuredClone(products.filter(x => !!x))
    checked_products = checked_products.reduce((acc, obj) => {
      if (is_block(obj)) {
        acc.push(obj)
        acc.push([])
      } else {
        acc[acc.length - 1].push(obj)
      }
      return acc
    }, [[]])

    checked_products = checked_products.filter(x => is_block(x) || x.length > 0)
    return checked_products
  }

  const checkSingle = ({initProducts, coll}) => {
    const { product_lines, handle } = coll

    let new_shown = initProducts
    const is_grouped = new_shown.find(x => x?.hasOwnProperty('products'))

    let pl_ids
    let alt_pls = product_lines.filter(x => !!x &&x.is_alt)
    alt_pls = alt_pls.map(x => x.pima_id)
    if (handle.includes('short-and-tall')) {
      alt_pls = []
    }

    if (!is_grouped) {
      let pls_used = []
      new_shown = new_shown.filter(x => {
        if (alt_pls.includes(x.pl_pima)) return false
        if (x.pl_pima === 99998) return x 
        if (!pls_used.includes(x.pl_pima)) {
          pls_used.push(x.pl_pima)
          return x
        }
        return false
      })
    } else {
      new_shown = new_shown.map(grp => {
        pl_ids = [...new Set( grp.products.map(x => x.pl_pima) )]
        pl_ids = pl_ids.filter(x => !alt_pls.includes(x))
        grp.products = pl_ids.map(id => grp.products.find(x => x?.pl_pima === id))
        return grp
      })
    }
    return new_shown
  }


  const checkGroupNav = ({coll}) => {
    const group_blockers = coll.group_blockers
    const { grp_default } = coll.rules || {}
    if (!grp_default) return false

    const groups = JSON.parse(JSON.stringify(coll.groups))

    const group_name = grp_default.includes('group') ? grp_default : `group${grp_default}`
    let group_objs = groups.filter(x => x.type === group_name)
    group_objs = group_objs.filter(x => !group_blockers.includes(x.mid) && notBlank(x.data.image) )
    group_objs = group_objs.filter(x => !!x)

    group_objs = group_objs.map(grp => {
      const group_prods = coll.prods_grouped.find(x => x?.mid === grp.mid)
      if (group_prods && group_prods.hasOwnProperty('products')) {
        grp.data.count = group_prods.products.length
      }
      return grp
    })

    return group_objs
  }


  const catsGroups = ({coll, allProducts}) => {
    const allCats = coll.all_cats
    return allCats.map((cat,index) => {
      let prods = allProducts.filter(x => x.category === cat)
      return {
        mid: 77770 + index,
        type: 'groupall',
        data: {
          name: cat.replace('Womens ',''),
          bullets: null,
          callouts: null,
          description: null,
          count: 0,
          group_by_pl: true,
          image: null
        },
        products: prods.map(x => x?.mid)
      }
    })
  }

  const catsProds = (cats_groups) => {
    return cats_groups.map(cat => {
      return {
        mid: cat.mid,
        products: cat.products
      }
    })
  }

  return { fillCollection, fillData, parseFilters }
}

export default PlpInit







